import React, { useEffect } from "react";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Services from "@/components/Services";
import AboutTeam from "@/components/AboutTeam";
import Process from "@/components/Process";
import VisualBand from "@/components/VisualBand";
import Collaborations from "@/components/Collaborations";
import Fees from "@/components/Fees";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import CookieBanner from "@/components/CookieBanner";

const VISUAL_BAND_IMG =
  "https://images.pexels.com/photos/16167849/pexels-photo-16167849.jpeg?auto=compress&cs=tinysrgb&w=2000";

const Home = () => {
  useEffect(() => {
    document.title = "PORT'S COLLECTORS · Derecho marítimo y portuario";
  }, []);

  return (
    <div data-testid="page-home" className="bg-white">
      <Navbar />
      <main>
        <Hero />
        <Services />
        <AboutTeam />
        <Process />
        <VisualBand
          image={VISUAL_BAND_IMG}
          alt="Vista aérea de puerto profesional"
          caption="· Compromiso institucional"
          quote="Liberar el amarre y reducir el impacto operativo del puerto."
          testId="visual-band-mid"
        />
        <Collaborations />
        <Fees />
        <Contact />
      </main>
      <Footer />
      <CookieBanner />
    </div>
  );
};

export default Home;
